export const PATH_COMPANY = '/api/v2/company';
export const PATH_COMPANY_NAME = '/api/v2/companyName';
